import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
history.goToError = (code = 500) => {
    history.push(`/${code}`);
    // eslint-disable-next-line no-self-assign
    window.location.href = window.location.href;
};
export default history;